import React from "react";
import { useLocation } from "react-router-dom";
import { IS_DEMO } from "@shape/reef-shared";
import UserInfo from "ui/UserInfo";
import { Routes } from "routes";
import { TopContainer, LogoImage, Login, DividerBar } from "./styled";

const TopBar: React.FC = () => {
  const location = useLocation();
  if (location.pathname === Routes.LoginPage) return null;

  return (
    <TopContainer>
      <LogoImage>
        <img src="/images/REEF.svg" alt="reef logo" />
        {!IS_DEMO && (
          <>
            <DividerBar />
            <img src="/images/modec white.svg" alt="modec logo" height={22} />
          </>
        )}
      </LogoImage>
      <Login>
        <UserInfo />
      </Login>
    </TopContainer>
  );
};

export default TopBar;
